<div class="component-viewer">
    <mat-card>
        <mat-card-header style="display: inline;">
            <div class="row w-100">
                <div class="col-6 text-start">
                    <h2 class="mb-0">League Members</h2>
                </div>
                <div class="col-6 text-end">
                    <button mat-raised-button (click)="onCreate()" [disabled]="!selectedLeagueId">
                        Add Member <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>
        </mat-card-header>
        <mat-card-content>
            <div class="row w-75 mb-3">
                <div class="col-md-6">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>League</mat-label>
                        <mat-select [(ngModel)]="selectedLeagueId" (selectionChange)="onLeagueChange()" 
                            [ngModelOptions]="{standalone: true}">
                            <mat-option *ngFor="let league of leagues" [value]="league.id">
                                {{league.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <gt-table *ngIf="selectedLeagueId" [loading]="isLoading" [defaultPageSize]="10" 
                [updateFilterEvent]="updateFilterEvent" [filter]="filter" [data]="members" 
                (filterChanged)="getMembers()" [placeholder]="'Search by member name or email'">
            </gt-table>
            
            <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
            
            <table mat-table [dataSource]="members" matSort (matSortChange)="sortData($event)" *ngIf="!isLoading">
                <ng-container matColumnDef="firstName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="firstName"> First Name </th>
                    <td mat-cell *matCellDef="let member"> {{member.firstName}} </td>
                </ng-container>
                <ng-container matColumnDef="lastName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="lastName"> Last Name </th>
                    <td mat-cell *matCellDef="let member"> {{member.lastName}} </td>
                </ng-container>
                <ng-container matColumnDef="email">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header="email"> Email </th>
                    <td mat-cell *matCellDef="let member"> {{member.email || '-'}} </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef> Actions </th>
                    <td mat-cell *matCellDef="let member">
                        <button mat-icon-button [matMenuTriggerFor]="actionsMenu">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #actionsMenu>
                            <button mat-menu-item (click)="onAddToIteration(member)">
                                <mat-icon>calendar_today</mat-icon>
                                <span>Add to Iteration</span>
                            </button>
                            <mat-divider></mat-divider>
                            <button mat-menu-item (click)="onEdit(member)">
                                <mat-icon>edit</mat-icon>
                                <span>Edit</span>
                            </button>
                            <button mat-menu-item (click)="onDelete(member)">
                                <mat-icon>delete</mat-icon>
                                <span>Delete</span>
                            </button>
                        </mat-menu>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

            <div *ngIf="members.length === 0 && !isLoading && selectedLeagueId" class="text-center py-5">
                <p  [ngClass]="{'text-muted': !isDarkMode, 'text-muted-dark-mode': isDarkMode}">No members yet. Click "Add Member" to create the first one.</p>
            </div>
            
            <div *ngIf="!selectedLeagueId" class="text-center py-5">
                <p [ngClass]="{'text-muted': !isDarkMode, 'text-muted-dark-mode': isDarkMode}">Please select a league to view its members.</p>
            </div>
        </mat-card-content>
    </mat-card>
</div>

